import { render } from "./GameIntro.vue?vue&type=template&id=50291389&scoped=true"
const script = {}

import "./GameIntro.vue?vue&type=style&index=0&id=50291389&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50291389"]])

export default __exports__